import Cherry from 'cherry-markdown/dist/cherry-markdown.core';
import Viewer from 'viewerjs';
import {
  INodeList,
  IProjectInfo,
  IProjectDocInfoMenu,
  IContentNav,
} from '../../../model/api-modules/document';

export const getDocumentParams = () => {
  const paths = location.pathname.split('/');
  const projectIdIndex = paths.findIndex((v) => +v);
  const projectId = paths[projectIdIndex] || '';
  const docId = paths[projectIdIndex + 1] || '';
  return { projectId, docId };
};

export const getDocumentUrl = (
  isDocPublicRoute: boolean,
  projectId: string | number,
  docId?: string | number
) => {
  const docUrl = isDocPublicRoute ? '/doc-public' : '/doc';
  const url = `${location.origin}${docUrl}/detail/${projectId}${
    docId && +docId ? `/${docId}` : ''
  }`;
  return url;
};

// 主要是链接的转换
export const markdownFormatConvert = (
  originalContent: string | null,
  nodeList: INodeList,
  currentProject: IProjectInfo | undefined
) => {
  const documentPathArr = originalContent
    ? originalContent.match(/\[(.*)\]\((.*\.md)\)/g)
    : null;
  let newOriginalContent = originalContent;
  if (documentPathArr && documentPathArr.length > 0) {
    // 如果存在相对路径的文档链接地址，替换链接地址
    let tmpDocumentContent = originalContent || '';
    documentPathArr.forEach((pa: any) => {
      // match函数返回的结果包含了开始和结束的符号，需要手动去掉
      const urlReg = /\((.+?)\)/gi;
      const urlText = pa.match(urlReg);
      const titleReg = /\[(.+?)\]/gi;
      let titleText = pa.match(titleReg);
      // 去掉中括号
      titleText = titleText[0].replace(/(^\[*)|(\]*$)/g, '');
      // 去掉小括号
      const truePath = urlText[0]
        .replace(/(^\(*)|(\)*$)/g, '')
        .replace(/(^\/*)|(\/*$)/g, '');
      const pathId = getDocumentId(truePath, titleText, nodeList);
      const url = `detail?projectId=${currentProject?.id}&docId=${pathId}`;
      tmpDocumentContent = tmpDocumentContent.replace(truePath, url);
    });
    newOriginalContent = tmpDocumentContent;
  }
  return newOriginalContent
    ? newOriginalContent
        .replace(
          // eslint-disable-next-line no-useless-escape
          /\/storage\/[0-9]+\/[0-9]+\-[0-9]+\/[a-zA-Z0-9]+/g,
          '/api/website/document/proxy$&'
        )
        /*
内外网的写了两个链接（以 | 符号做分隔），一个内网的（gcloud.oa.com）,一个外网的（gcloud.tencent.com）,外网匹配外网域名的链接
(http://gcloud.oa.com/pages/documents/details.html?projectId=222&docId=290|//gcloud.tencent.com/pages/documents/details.html?projectId=222&docId=1658)
(//gcloud.oa.com/pages/documents/details.html?projectId=222&docId=290|https://gcloud.tencent.com/pages/documents/details.html?projectId=222&docId=1658)
(//gcloud.tencent.com/pages/documents/details.html?projectId=222&docId=1658|http://gcloud.oa.com/pages/documents/details.html?projectId=222&docId=290)
*/
        .replace(
          // eslint-disable-next-line
          /\((((((http|https):)?\/\/)?(gcloud|gclouddev).tencent.com)(\/detail)([\w\W]*?))\|(((((http|https):)?\/\/)?(gcloud|gclouddev).oa.com)(\/detail)([\w\W]*?))\)/g,
          // eslint-disable-next-line
          '($7$8)'
        )
        .replace(
          // eslint-disable-next-line
          /\((((((http|https):)?\/\/)?(gcloud|gclouddev).oa.com)(\/detail)([\w\W]*?))\|(((((http|https):)?\/\/)?(gcloud|gclouddev).tencent.com)(\/detail)([\w\W]*?))\)/g,
          // eslint-disable-next-line
          '($15$16)'
        )
        // eslint-disable-next-line
        .replace(
          /\(((((http|https):)?\/\/)?(gcloud|gclouddev).(oa|tencent).com)?(\/detail)([\w\W]*?)\)/g,
          '($7$8)'
        )
    : '';
};

const getDocumentId = (
  path: string,
  titleName: string,
  nodeList: INodeList
) => {
  const currentUrlParams = new URLSearchParams(window.location.search);
  // const projectId = currentUrlParams.get('projectId');
  const docId = currentUrlParams.get('docId') || '';
  const pathArr = path.split('/');
  let currentNode: any = searchPid(docId, nodeList);
  let initDocId = docId;
  let initPid = currentNode.pid;
  let documentId = 0;
  pathArr.forEach((p, i) => {
    switch (p) {
      case '..':
        currentNode = searchPid(initPid, nodeList);
        initPid = currentNode.pid;
        initDocId = currentNode.id;
        break;
      case '.':
        break;
      default:
        if (i === pathArr.length - 1) {
          const fileName = p.replace('.md', '');
          if (currentNode.nodes && currentNode.nodes.length > 0) {
            // 如果是目录的跳转链接，传入的Pid为当前目录的ID
            documentId = searchDocumentByPidAndName(
              initDocId,
              titleName,
              nodeList
            );
          } else {
            documentId = searchDocumentByPidAndName(
              initPid,
              fileName,
              nodeList
            );
          }
          return documentId;
        }
        documentId = searchDocumentByPidAndName(initPid, p, nodeList);
        initPid = documentId;

        break;
    }
  });
  return documentId;
};

const searchPid = (docId: string, nodeList: INodeList) => {
  let currentNode = {};
  const newNodeList = nodeList.node;
  newNodeList.forEach((n: IProjectDocInfoMenu) => {
    if (n.id === parseInt(docId, 10)) {
      currentNode = n;
    }
  });
  return currentNode;
};

const searchDocumentByPidAndName = (
  pid: string,
  name: string,
  nodeList: INodeList
) => {
  let tmpId = 0;
  const newNodeList = nodeList.node;
  newNodeList.forEach((n: IProjectDocInfoMenu) => {
    if (n.pid === parseInt(pid, 10) && n.name === name) {
      tmpId = n.id;
    }
  });
  return tmpId;
};

// 获取正文页右侧导航
export const getContentNav = (contentHtmlStr: string) => {
  if (!contentHtmlStr) {
    return [];
  }
  const hDomList = contentHtmlStr.match(
    // eslint-disable-next-line
    /<h[1-6]{1}[^>]*>([\s\S]*?)<\/h[1-6]{1}>/g
  );
  if (!Array.isArray(hDomList)) {
    return [];
  }
  const dirTree: IContentNav[] = [];
  let preDir: IContentNav | undefined;
  let parentDir: IContentNav | undefined;
  hDomList.forEach((hDom, index) => {
    // eslint-disable-next-line
    const startIndex = hDom.indexOf('id="');
    // eslint-disable-next-line
    const endIndex = hDom.indexOf('">');
    if (startIndex !== -1 && endIndex !== -1) {
      const re = /<h([1-6]{1})[^>]*>([\s\S]*?)<\/h[1-6]{1}>/;
      const hLevel = Number(hDom.replace(re, '$1'));
      // 最多读取到h3
      if (hLevel < 4) {
        const domId = hDom.slice(startIndex + 4, endIndex);
        const titleContent = hDom.replace(re, '$2');
        // 有可能匹配到的是这样’我<strong>是</strong>h1<em>斜体</em>介绍‘ 里面还有标签（直接去掉标签）
        const title = titleContent.replaceAll(
          /<([\s\S]*?)>|<\/([\s\S]*?)>/g,
          ''
        );
        const currentDir = {
          id: index + 1, // 用于点击的时候选中态
          title,
          domId,
          hLevel,
          isOpen: true,
          pid: 0,
        };
        if (preDir) {
          if (currentDir.hLevel > preDir.hLevel) {
            currentDir.pid = preDir.id;
          } else {
            parentDir = preDir;
            while (parentDir && currentDir.hLevel <= parentDir.hLevel) {
              // eslint-disable-next-line
              parentDir = dirTree.find((dir) => dir.id === parentDir!.pid);
            }
            if (parentDir) {
              currentDir.pid = parentDir.id;
            } else {
              // 如果未找到父节点，将 pid 设置为 0
              currentDir.pid = 0;
            }
          }
        } else {
          currentDir.pid = 0;
        }
        preDir = currentDir;
        dirTree.push(currentDir);
      }
    }
  });
  dirTree.forEach((item: IContentNav) => {
    const elementItem = document.getElementById(item.domId);
    elementItem?.classList.add('right-section-item');
    if (item.pid !== 0) {
      const findParent: any = dirTree.find((i: any) => i.id === item.pid);
      if (findParent) {
        if (!Array.isArray(findParent.children)) {
          findParent.children = [];
        }
        findParent.children.push(item);
      }
    }
  });
  return dirTree.filter((i: IContentNav) => i.pid === 0);
};

// 主要是刷新页面时用到
export const goDocAnchorPoint = (
  hashAnchorPoint: string,
  contentNav: ReadonlyArray<IContentNav>,
  setAnchorTitleId: (value: string) => void
) => {
  let newHashAnchorPoint = hashAnchorPoint.replace('#', '');
  const chineseRegex = /[\u4e00-\u9fa5]/;
  if (newHashAnchorPoint) {
    if (chineseRegex.test(newHashAnchorPoint)) {
      newHashAnchorPoint = encodeURIComponent(newHashAnchorPoint);
    }
    // 先延迟0.5秒执行，jquery的ready不行
    setTimeout(() => {
      const hashAnchorPointDom = document.getElementById(newHashAnchorPoint);

      if (hashAnchorPointDom) {
        // const headerHeight = $('.p-header-nav-box .p-header-nav').height();
        const headerNavBox = document.querySelector(
          '.p-header-nav-box .p-header-nav'
        );
        const headerHeight = headerNavBox?.clientHeight || 0;
        // 原生document.getElementById('准备机器基础环境').offsetTop和jquery $('#准备机器基础环境').offset().top获取到的值不一样，相差100多
        // 获取原始离底部高度暂且用原生的
        // 滚动时加上头部的高度，以免被头部挡住

        // $('.c-main-content-wapper').scrollTop(hashAnchorPointDom.offsetTop + headerHeight);
        const mainContentWrapper = document.querySelector(
          '.c-main-content-wapper'
        );
        const scrollPosition = hashAnchorPointDom.offsetTop + headerHeight;
        if (mainContentWrapper) {
          // 修改布局后没有mainContentWrapper没有scrollTop改为设置window滚动条位置
          // mainContentWrapper.scrollTop = scrollPosition;
          window.scrollTo({ left: 0, top: scrollPosition + 120 });
        }
        const anchorInfo: any = calcGetAnchorInfo(
          contentNav,
          newHashAnchorPoint
        );
        if (anchorInfo) {
          setAnchorTitleId(`menu-${anchorInfo.domId}`);
        }
      }
    }, 500);
  }
};

const calcGetAnchorInfo = (
  anchorList: ReadonlyArray<IContentNav>,
  hashAnchorPoint: string
) => {
  let anchorInfo;
  anchorList.some((anchorItem: IContentNav) => {
    if (anchorItem.domId === hashAnchorPoint) {
      anchorInfo = anchorItem;
      return true;
    }
    if (Array.isArray(anchorItem.children) && anchorItem.children.length > 0) {
      return calcGetAnchorInfo(anchorItem.children, hashAnchorPoint);
    }
    return false;
  });
  return anchorInfo;
};

export const cherryMarkdown = (domId: string, mdStr: string) => {
  const cherryConfig = {
    id: domId,
    externals: {
      echarts: window.echarts,
      katex: window.katex,
      MathJax: window.MathJax,
    },
    engine: {
      global: {
        urlProcessor(url: string) {
          return url;
        },
      },
      syntax: {
        codeBlock: {
          theme: 'tomorrow night',
          editCode: false,
          // indentedCodeBlock是缩进代码块是否启用的开关（插件6.x之后加的操作，这个会引起代码识别错乱），去掉这个操作
          indentedCodeBlock: false,
        },
        fontEmphasis: {
          allowWhitespace: true, // 是否允许首尾空格(为true的话字体语法首尾嵌套可以识别，例如：**加粗，*斜体***  false的话识别不了)
        },
        mathBlock: {
          engine: 'MathJax', // katex或MathJax
          // src: '/plugins/mathjax-3/es5/tex-svg.js', // 如果使用MathJax将js在此处引入，katex则需要将js提前引入
          src: `${location.origin}/js/mathjax-3/es5/tex-svg.js`, // 如果使用MathJax将js在此处引入，katex则需要将js提前引入
          // plugins: true
        },
        inlineMath: {
          engine: 'MathJax', // katex或MathJax
          // src: '/plugins/mathjax-3/es5/tex-svg.js', // 如果使用MathJax将js在此处引入，katex则需要将js提前引入
          src: `${location.origin}/js/mathjax-3/es5/tex-svg.js`, // 如果使用MathJax将js在此处引入，katex则需要将js提前引入
        },
        emoji: {
          useUnicode: false,
          customResourceURL:
            'https://github.githubassets.com/images/icons/emoji/unicode/${code}.png?v8',
          upperCase: true,
        },
      },
      customSyntax: {},
    },
    toolbars: {
      toolbar: false,
    },
    editor: {
      defaultModel: 'previewOnly',
    },
    callback: {
      // 初始化渲染完成时
      afterInit: (markdownText: string, htmlStr: string) => {
        // 修改替换codeGroup,组件不识别，找不到其他方法，自己手动替换dom
        calcCodeGroup(domId, htmlStr);
      },
      onClickPreview(e: React.MouseEvent<HTMLElement>) {
        const { target } = e;
        if (target instanceof HTMLElement && target.tagName === 'IMG') {
          const viewer = new Viewer(target, {
            button: false,
            navbar: false,
            title: [
              1,
              (image: any, imageData: any) =>
                `${image.alt.replace(/#.+$/, '')} (${
                  imageData.naturalWidth
                } × ${imageData.naturalHeight})`,
            ],
          });
          viewer.show();
        }
      },
    },
    previewer: {
      // 自定义markdown预览区域class
      // className: 'markdown',
      lazyLoadImg: {
        // 不进行懒加载处理的图片数量，如果为0，即所有图片都进行懒加载处理， 如果设置为-1，则所有图片都不进行懒加载处理（所有图片都需要进行懒加载，不然的话兼容不了以前的图片大小格式）
        noLoadImgNum: 0,
        // 同一时间最多有几个图片请求，最大同时加载6张图片
        maxNumPerTime: 6,
        // 加载图片时如果需要展示loading图，则配置loading图的地址
        loadingImgPath:
          'https://gcloudintl-pre-1316968258.cos.ap-singapore.myqcloud.com/doc/static/upload_file/0p4PDVuLSTezZzIPhsbkmIj42YbZPxmjhmnwLRri.gif',
        // 加载一张图片之后的回调函数，如果图片加载失败，则不会回调该函数
        afterLoadOneImgCallback(img: HTMLImageElement) {
          let isHasStyleWidthHeight = false;
          let imgStyle = '';
          if (img.hasAttribute('style')) {
            imgStyle = img.getAttribute('style') || '';
            const imgStyleArr = imgStyle.split(';');
            const styleAttributeArr: string[] = [];
            imgStyleArr.forEach((styleItem) => {
              const styleItemArr = styleItem.split(':');
              if (styleItemArr.length > 0) {
                styleAttributeArr.push(styleItemArr[0]);
              }
            });
            if (
              styleAttributeArr.includes('width') ||
              styleAttributeArr.includes('height') ||
              styleAttributeArr.includes('max-width') ||
              styleAttributeArr.includes('max-height')
            ) {
              isHasStyleWidthHeight = true;
            }
          }
          // 有宽度或者高度的时候不设置（以插件默认的为准）
          if (
            !(
              isHasStyleWidthHeight ||
              img.hasAttribute('width') ||
              img.hasAttribute('height')
            )
          ) {
            // 兼容以前设置图片大小格式（例如：![size:100,200](图片地址)）
            const imgAlt = img.getAttribute('alt');
            const reg = /(size:)([1-9][0-9]*)((,)([1-9][0-9]*))?/;
            if (imgAlt && reg.test(imgAlt)) {
              // 设置最大宽高图片不会变形，设置固定宽高会变形
              // const width = imgAlt.replace(reg, '$2');
              // const height = imgAlt.replace(reg, '$5');
              // let altImgStyle = `max-width:${width}px !important;`;
              const altImgStyle = 'max-width: 100% !important;';
              // if (height) {
              //     altImgStyle += `max-height:${height}px !important;`;
              // }
              let newImgStyle = '';
              if (imgStyle) {
                // 有可能有 ; 符号，去掉好拼接
                imgStyle = imgStyle.replace(/(;$)/g, '');
                newImgStyle = `${imgStyle};${altImgStyle}`;
              } else {
                newImgStyle = altImgStyle;
              }
              img.setAttribute('style', newImgStyle);
            }
          }
        },
      },
    },
    keydown: [],
  };
  const config: any = Object.assign({}, cherryConfig, { value: mdStr });
  return new Cherry(config);
};

const calcCodeGroup = (domId: string, htmlStr: string) => {
  const codeGroupRe = getCodeGroupRe(true);
  const codeGroupDomList = htmlStr.match(codeGroupRe);
  if (Array.isArray(codeGroupDomList)) {
    let newHtmlStr = htmlStr;
    codeGroupDomList.forEach((codeGroupDom) => {
      newHtmlStr = newHtmlStr.replace(
        codeGroupDom,
        codeGroupConvert(codeGroupDom)
      );
    });
    // #domId是整个文档父节点，.cherry-previewer是默认渲染区的class
    // $(`#${domId} .cherry-previewer`).html(htmlStr);
    // setTimeout(() => {
    //     // 先清除之前的，避免多个监听
    //     $('.code-group-tabs .tab-title li').unbind('click');
    //     // 正文 -- tabs切换
    //     $('.code-group-tabs .tab-title li').click(function () {
    //         $(this).css('border-color', '#165DFF').css('color', '#165DFF').siblings().css('border-color', 'transparent').css('color', '#000');
    //         const currentCodeDataSign = $(this).attr('current-code-data-sign');
    //         if (!$(`div[data-sign='${currentCodeDataSign}']`).hasClass('c-code-show')) {
    //             $(`div[data-sign='${currentCodeDataSign}']`).addClass('c-code-show');
    //         }
    //         const otherCodeDataSignStr = $(this).attr('other-code-data-sign');
    //         const otherCodeDataSignList = otherCodeDataSignStr.split('|');
    //         otherCodeDataSignList.forEach((otherCodeDataSign) => {
    //             $(`div[data-sign='${otherCodeDataSign}']`).removeClass('c-code-show');
    //             $(`div[data-sign='${otherCodeDataSign}']`).addClass('c-code-hide');
    //         });
    //     });
    // }, 50);
    const cherryPreviewer = document.querySelector(
      `#${domId} .cherry-previewer`
    );

    if (cherryPreviewer) {
      cherryPreviewer.innerHTML = newHtmlStr;

      setTimeout(() => {
        const tabTitles = Array.from(
          document.querySelectorAll('.code-group-tabs .tab-title li')
        ) as HTMLElement[];

        // 先清除之前的，避免多个监听
        tabTitles.forEach((tabTitle) => {
          tabTitle.removeEventListener('click', tabClickHandler);
        });

        // 正文 -- tabs切换
        tabTitles.forEach((tabTitle) => {
          tabTitle.addEventListener('click', tabClickHandler);
        });
      }, 50);
    }
  }
};

const tabClickHandler = (event: Event) => {
  const tabTitle = event.currentTarget as HTMLElement;

  // 处理 tabs 切换逻辑
  tabTitle.style.borderColor = '#165DFF';
  tabTitle.style.color = '#165DFF';

  if (!tabTitle.parentNode) {
    return;
  }
  const siblings = Array.from(tabTitle.parentNode.children) as HTMLElement[];
  siblings.forEach((sibling: HTMLElement) => {
    if (sibling !== tabTitle) {
      const siblingStyle = sibling.style;
      siblingStyle.borderColor = 'transparent';
      siblingStyle.color = '#000';
    }
  });
  const currentCodeDataSign =
    tabTitle.getAttribute('current-code-data-sign') || '';
  const currentCodeDataElement = document.querySelector(
    `div[data-sign='${currentCodeDataSign}']`
  ) as HTMLElement;

  if (
    currentCodeDataElement &&
    !currentCodeDataElement.classList.contains('c-code-show')
  ) {
    currentCodeDataElement.classList.add('c-code-show');
  }

  const otherCodeDataSignStr =
    tabTitle.getAttribute('other-code-data-sign') || '';
  const otherCodeDataSignList = otherCodeDataSignStr.split('|');

  otherCodeDataSignList.forEach((otherCodeDataSign) => {
    const otherCodeDataElement = document.querySelector(
      `div[data-sign='${otherCodeDataSign}']`
    ) as HTMLElement;

    if (otherCodeDataElement) {
      otherCodeDataElement.classList.remove('c-code-show');
      otherCodeDataElement.classList.add('c-code-hide');
    }
  });
};

const getCodeGroupRe = (isGlobal?: boolean) => {
  if (isGlobal) {
    // eslint-disable-next-line
    return /(<p[^>]*>(<br>|<br\/>)*?\{\%([\s\S]*?)codegroup([\s\S]*?)\%\}(<br>|<br\/>)*?<\/p>)([\s\S]*?)(<p[^>]*>(<br>|<br\/>)*?\{\%([\s\S]*?)endcodegroup([\s\S]*?)\%\}(<br>|<br\/>)*?<\/p>)/g;
  }
  // eslint-disable-next-line
  return /(<p[^>]*>(<br>|<br\/>)*?\{\%([\s\S]*?)codegroup([\s\S]*?)\%\}(<br>|<br\/>)*?<\/p>)([\s\S]*?)(<p[^>]*>(<br>|<br\/>)*?\{\%([\s\S]*?)endcodegroup([\s\S]*?)\%\}(<br>|<br\/>)*?<\/p>)/;
};

const codeGroupConvert = (codeGroupDom: string) => {
  const codeGroupRe = getCodeGroupRe();
  const allCodeDom = codeGroupDom.replace(codeGroupRe, '$4');
  const codeDomRe =
    // eslint-disable-next-line
    /(<div)([\s\S]*?)(data-sign=\"([\s\S]*?)\"([\s\S]*?)data-type=\"codeBlock\"([\s\S]*?)<\/pre>([\s\S]*?)<\/div>)/g;
  const codeDomList = allCodeDom.match(codeDomRe);
  const newCodeDomList: string[] = [];
  const dataSignList: string[] = [];
  codeDomList?.forEach((codeDom) => {
    const dataSign = codeDom.replace(codeDomRe, '$4');
    dataSignList.push(dataSign);
  });
  const languageTextList: string[] = [];
  codeDomList?.forEach((codeDom, codeDomIndex) => {
    const attributeList = [];
    if (codeDomIndex > 0) {
      attributeList.push(' class="c-code-hide" ');
    } else {
      attributeList.push(' class="c-code-show" ');
    }
    const languageList = codeDom.match(
      // eslint-disable-next-line
      /<option([\s\S]*?)value=\"([\s]*?)\"([\s\S]*?)(selected=\"selected\")[^>]*>([\s\S]*?)<\/option>/g
    );
    if (Array.isArray(languageList)) {
      const languageText = languageList[0].replace(
        // eslint-disable-next-line
        /<option([\s\S]*?)value=\"([\s]*?)\"([\s\S]*?)(selected=\"selected\")[^>]*>([\s\S]*?)<\/option>/,
        '$5'
      );
      languageTextList.push(languageText);
    } else {
      languageTextList.push('');
    }
    const newCodeDom = codeDom.replace(
      codeDomRe,
      `$1${attributeList.join('')}$3`
    );
    newCodeDomList.push(newCodeDom);
  });
  const tabTitleList = [];
  if (languageTextList.length > 0) {
    tabTitleList.push('<ul class="tab-title">');
    languageTextList.forEach((languageText: string, index: number) => {
      const attributeList = [];
      const currentDataSign = dataSignList[index];
      attributeList.push(` current-code-data-sign='${currentDataSign}' `);
      const otherDataSignList = dataSignList.filter(
        (dataSign) => dataSign !== currentDataSign
      );
      attributeList.push(
        ` other-code-data-sign='${otherDataSignList.join('|')}' `
      );
      // languageText = languageText ? languageText : '--';
      const newLanguageText = languageText ? languageText : '--';
      tabTitleList.push(
        `<li ${attributeList.join('')}>${newLanguageText}</li>`
      );
    });
    tabTitleList.push('</ul>');
  }
  const tabTitleStr = tabTitleList.join('');
  return `
        <div class='code-group-tabs' data-type='code-group-tabs'>
        ${tabTitleStr}
        </div>
    ${newCodeDomList.join('')}
    `;
};

const calcDocData = (
  menus: ReadonlyArray<IProjectDocInfoMenu> | undefined,
  documents: Array<IProjectDocInfoMenu>
) => {
  menus?.forEach((item: IProjectDocInfoMenu) => {
    documents.push(item);
    if (Array.isArray(item.nodes) && item.nodes.length > 0) {
      calcDocData(item.nodes, documents);
    }
  });
  return documents;
};

export const getDocuments = (
  menus: ReadonlyArray<IProjectDocInfoMenu> | undefined
) => {
  let documents: Array<IProjectDocInfoMenu> = [];

  documents = calcDocData(menus, documents);
  return documents;
};

export const getActiveDocuments = (
  documents: ReadonlyArray<IProjectDocInfoMenu>,
  docId: number | string
) => {
  if (!documents) return;
  // 保存选中的文档数据 例如：[父，子，子]
  const activeDocuments: Array<IProjectDocInfoMenu> = [];
  const newDocId = calcActiveDocuments(documents, docId, activeDocuments);

  // 查找最大父类文档
  const findFirentDoc = documents.find((i) => i.id === Number(newDocId));
  if (findFirentDoc && activeDocuments.indexOf(findFirentDoc) === -1) {
    activeDocuments.push(findFirentDoc);
  }
  return activeDocuments.reverse();
};

const calcActiveDocuments = (
  documents: ReadonlyArray<IProjectDocInfoMenu>,
  docTreeId: number | string,
  activeDocuments: Array<IProjectDocInfoMenu>
) => {
  if (!documents) return;
  let docId = docTreeId;
  // eslint-disable-next-line array-callback-return
  documents.some((item) => {
    // 先在每篇文档的nodes下找文档
    if (Array.isArray(item.nodes)) {
      const findNode = item.nodes.find(
        (i: IProjectDocInfoMenu) => i.id === Number(docTreeId)
      );

      if (findNode) {
        if (activeDocuments.indexOf(findNode) === -1) {
          activeDocuments.push(findNode);
        }
        // 保存一下文档值，添加最大父类文档的时候用到
        // eslint-disable-next-line no-param-reassign
        docId = item.id;

        calcActiveDocuments(documents, item.id, activeDocuments);
        return true;
      }
    }
  });
  return docId;
};
